import { combineReducers } from "redux";
import globalLoaderSlice from "../components/backdrop/backdropSlice";
import auditSlice from "../pages/auditTrails/auditSlice";
import brandSlice from "../pages/brands/brandSlice";
import campaignSlice from "../pages/campaigns/campaignSlice";
import companySlice from "../pages/company/companySlice";
import dashboardSlice from "../pages/dashboard/dashboardSlice";
import notificationSlice from "../pages/notifications/notificationSlice";
import privacySlice from "../pages/privacy/privacySlice";
import subscriptionSlice from "../pages/subscriptions/subscriptionSlice";
import userSlice from "../pages/users/userSlice";
import walletSlice from "../pages/wallet/walletSlice";
import wishlistSlice from '../pages/company-wishlist/wishlistSlice'
import addEditWishlist from '../pages/company-wishlist/addEditWishlistSlice'
import kycSlice from "../pages/kyc/kycSlice";
import communityPostSlice from "../pages/notifications/communityPosts/communityPostsSlice";
import { api } from "./api";
import commonSlice from "./commonSlice";
import { firebaseApi } from "./firebaseApi";
import appReducer, { appSlice } from "./reducer";

const mainReducer = combineReducers({
    companySlice,
    brandSlice,
    campaignSlice,
    commonSlice,
    userSlice,
    privacySlice,
    auditSlice,
    kycSlice,
    dashboardSlice,
    globalLoaderSlice,
    subscriptionSlice,
    walletSlice,
    notificationSlice,
    wishlistSlice,
    addEditWishlist,
    communityPostSlice,
    [appSlice.name]: appReducer,
    [api.reducerPath]: api.reducer,
    [firebaseApi.reducerPath]: firebaseApi.reducer,
});
const rootReducer = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    state = undefined;
  }

  return mainReducer(state, action);
};
export default rootReducer;